import { List } from 'immutable';
import { secondaryLineItemConstants } from '../constants';

export function secondary_line_items(state = {}, action) {
  switch (action.type) {
    case secondaryLineItemConstants.SECONDARY_LINE_ITEM_LIST_LOADING:
      return {
        ...state,
        listLoading: true
      };
    case secondaryLineItemConstants.SECONDARY_LINE_ITEM_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case secondaryLineItemConstants.SECONDARY_LINE_ITEM_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: [],
        listError: action.error
      };
    case secondaryLineItemConstants.SECONDARY_LINE_ITEM_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };
    case secondaryLineItemConstants.SECONDARY_LINE_ITEM_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: items.push(action.response),
        createLoading: false,
        createError: null
      };
    }
    case secondaryLineItemConstants.SECONDARY_LINE_ITEM_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case secondaryLineItemConstants.SECONDARY_LINE_ITEM_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case secondaryLineItemConstants.SECONDARY_LINE_ITEM_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const secondaryLineItemIndex = state.items.findIndex(val => val.id == action.response.id);

      if (secondaryLineItemIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(secondaryLineItemIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case secondaryLineItemConstants.SECONDARY_LINE_ITEM_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case secondaryLineItemConstants.SECONDARY_LINE_ITEM_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case secondaryLineItemConstants.SECONDARY_LINE_ITEM_DELETE_SUCCESS: {
      const { secondaryLineItemId } = action;

      if (!state.items) {
        return state;
      }

      const secondaryLineItemIndex = state.items.findIndex(val => val.id == secondaryLineItemId);

      if (secondaryLineItemIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(secondaryLineItemIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case secondaryLineItemConstants.SECONDARY_LINE_ITEM_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };
    case secondaryLineItemConstants.SECONDARY_LINE_ITEM_ERROR_RELOAD:
      return {
        ...state,
        createError: null,
        editError: null
      };

    default:
      return state;
  }
}
